export default {
  cloudInterface: {},
  callLog: {
    callLog: "调用日志",
    consumeLog: "消费日志",
    apiNameRequired: "请输入接口名称",
    proxyOrgNameRequired: "请输入调用方企业",
    callResultRequired: "请选择调用结果",
    success: "成功",
    failure: "失败",
    startTime: "开始日期",
    endTime: "结束日期",
    logList: "日志列表",
    // apiCode: "接口编码",
    apiName: "接口名称",
    responseCode: "响应编码",
    responseTime: "响应时长",
    proxyOrgName: "调用方企业",
    requestTime: "请求时间",
    callResult: "调用结果",
    baseInfo: "基本信息",
    requestHeader: "请求头",
    reqBody: "请求体",
    respBody: "响应体",
    // apiCode: "接口编码",
    apiName: "接口名称",
    proxyOrgName: "调用方",
    orgName: "服务提供方",
    requestTime: "请求时间",
    requestMethod: "请求方法",
    responseCode: "响应编码",
    responseTime: "响应时长",
    searchCondition: "搜索条件",
    proxyOrgNameRequired: "请选择调用方企业",
    timeRangeRequired: "选择时间日期",
    verificationResult: "验证结果",
    proofTheory: "验证结论：",
    linkAddress: "上链地址：",
    linkTime: "上链时间：",
    blockHeight: "区块高度：",
    goToAppeal: "前往申诉",
    appealInfo: "申诉信息",
    appealDetail: "申诉详情",
    appealEnterprise: "申请企业：",
    applicant: "申请人：",
    reasonForApplication: "申请理由：",
    attachments: "附件：",
    approvalOpinion: "审批意见：",
    file: "文件：",
    uploadFile: "上传文件",
    save: "保存",
    verificationAppeal: "验证申诉",
    cancel: "取消",
    appealReview: "申诉审核",
    verifyStatus: "验证状态",
    verified: '已验证',
    inVerification: "验证中",
    verifyUser: "提交人",
    verifyDate: "验证时间",
    fileDownload: "下载文件",
    show: "当前响应Body为文件内容，请下载后查看",
    name: "参数名",
    type: "类型",
    value: "值",
    normal: '正常',
    abnormal: "异常"

  },
  callStatistics: {
    tenMinutes: "十分钟",
    hour: "时",
    day: "日",
    week: "周",
    month: "月",
    year: "年",
    runNumber: "运行服务数量",
    callNumber: "服务调用次数",
    flowStatistics: "服务流量统计（kb）",
    averageRes: "平均响应时长（ms)",
    startPlaceholder: "开始日期时间",
    endPlaceholder: "结束日期时间",
    successTimes: "成功次数",
    errorTimes: "失败次数",
    totalCalls: "总调用次数",
    totalFlow: "总流量",
    network: "请求失败，",
    refresh: "点击刷新",
    empty: "暂无数据",
    successCount: "成功次数",
    failCount: "失败次数"
  },
  proxyLog: {},
  cloudInterface: {
    cloudApiList: "云端接口列表",
    authorizeApiList: "授权接口列表",
    searchCondition: "搜索条件",
    orgRequired: "请选择企业",
    // searchApiCode: "查询接口编码",
    searchApiName: "查询接口名称",
    searchCodeAndName: "查询接口编码/接口名称",
    // apiCode: "接口编码",
    apiName: "接口名称",
    // categoryName: "应用服务",
    apiClassify: "接口分类",
    remark: "描述",
    orgName: "所属企业",
    status: "状态",
    apply: "申请",
    detail: "详情",
    debug: "调试",
    delete: "删除",
    apiApply: "接口调用申请",
    reasonRequired: "请输入申请理由",
    baseInfo: "基本信息",
    requestHeader: "请求头",
    reqBody: "请求体",
    respBody: "响应体",
    visibleRange: "可见范围",
    classify: "所属分类",
    category: "接口应用",
    isExamine: "第三方调用是否需要审批",
    yes: "是",
    no: "否",
    apiProtocol: "接口协议",
    remark: "接口描述",
    apiUrl: "接口地址",
    requestMethod: "请求方法",
    aggree: "同意",
    reject: "拒绝",
    hiddenUrlTip: "请申请后前往授权接口列表查看",
    apiIntroduction: "API介绍",
    apiDefinition: "API请求&响应定义",
    apiPath: "接口路径",
    need: "需要",
    unNeed: "不需要",
    public: "公开接口",

    interfaceCenter: '接口中心',
    TCPCenter: "TCP中心",
    MQTTCenter: "MQTT中心",

    TCPName: 'TCP名称',
    describe: '描述',
    url: '原端口',
    forwardPort: '代理端口',
    TCPCenterSearchPlaceholder: '查询TCP名称',
    MQTTPlaceholder: "查询MQTT名称",

    mqttName: "名称",
    broker: "broker地址",
    topic: "Topic",
    orgName: "申请企业",
    describe: "描述"
  }
};



// WEBPACK FOOTER //
// ./src/views/cloudInterface/cloudInterface.zh-CN.js